import { render } from "./AboutConf.vue?vue&type=template&id=400ad514&scoped=true"
import script from "./AboutConf.vue?vue&type=script&lang=js"
export * from "./AboutConf.vue?vue&type=script&lang=js"

import "./AboutConf.vue?vue&type=style&index=0&id=400ad514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-400ad514"]])

export default __exports__